import React from 'react';
import utils from '../../utils/utils.functions';
import numeral from 'numeral';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';

const customStyles = {
  rows: {
    style: {
      minHeight: '72px', // override the row height
    }
  },
  headCells: {
    style: {
      paddingLeft: '8px', // override the cell padding for head cells
      paddingRight: '8px',
    },
  },
  cells: {
    style: {
      paddingLeft: '8px', // override the cell padding for data cells
      paddingRight: '8px',
    },
  },
};

const colummnsWithFunc = () => {
  return [
    {
      name: 'Cantidad',
      selector: 'cantidad',
      sortable: true,
      width: '10%',
    },
    {
      name: 'Descripción',
      selector: 'descripcion',
      sortable: true,
    },
  ];
}

const colummnsWithFunc2 = (callbackDel) => {
  return [
    {
      name: 'Cantidad',
      selector: 'cantidad',
      sortable: true,
      width: '10%',
    },
    {
      name: 'Descripción',
      selector: 'descripcion',
      sortable: true,
    },
    {
      name: 'Acciones',
      grow: 0,
      cell: (row) => (
        <div style={{ margin: 5, display: 'flex' }}>
          <button onClick={() => callbackDel(row)} className="btnx btnx-warn icon-table">
            <FontAwesomeIcon icon={faTrashAlt} />
          </button>
        </div>
      )
    },
  ];
}


const colummnsBultos = (permisoUnitGuide) => {
  return [
    {
      name: 'Alto',
      selector: 'alto',
      sortable: true,
      cell: row => (
        numeral(row.alto).format('0.00')
      )
    },
    {
      name: 'Ancho',
      selector: 'ancho',
      sortable: true,
      cell: row => (
        numeral(row.ancho).format('0.00')
      )
    },
    {
      name: 'Largo',
      selector: 'largo',
      sortable: true,
      cell: row => (
        numeral(row.largo).format('0.00')
      )
    },
    {
      name: 'Peso',
      selector: 'peso',
      sortable: true,
      cell: row => (
        numeral(row.peso).format('0.00')
      )
    },
    {
      name: 'Ft3',
      selector: 'pie',
      sortable: true,
      cell: row => (
        numeral(row.pie).format('0.00')
      )
    },
    {
      name: 'Guia externa',
      selector: 'guia_externa',
      sortable: true,
      cell: row => {
        return row.guia_externa === '' || !row.guia_externa ? 'N/A' : row.guia_externa;
      }
    },
  ];
}


const colummnsPagos = () => {
  return [
    {
      name: 'Monto',
      selector: 'monto_pago',
      sortable: true,
      cell: row => (
        utils.formatMoney(row.monto_pago)
      )
    },
    {
      name: 'Forma de pago',
      selector: row => row.tipo_pago.description,
      sortable: true,
    },
    {
      name: 'Referencia',
      selector: row => row.referencia,
      sortable: true,
      cell: row => (
        !row.referencia ? 'N/A' : row.referencia
      )
    },
  ];
}

const columnsSeguro = () => {
  return [
    {
      name: 'Carga asegurada',
      selector: 'monto_carga',
      sortable: true,
      cell: row => (
        utils.formatMoney(row.monto_carga)
      )
    },
    {
      name: 'Total asegurado',
      selector: 'monto_seguro',
      sortable: true,
      cell: row => (
        utils.formatMoney(row.monto_seguro)
      )
    },
  ];
}



const tableDetalle = {
  customStyles,
  colummnsWithFunc,
  colummnsBultos,
  colummnsPagos,
  columnsSeguro,
  colummnsWithFunc2,
}

export default tableDetalle;